import axiosInstance from "../mainService";
const answerService = {
    getAnswer(search, page, limit, company){
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get(`/data/m151_answers/answer/${sanitizedSearch}/${page}/${limit}/${company}`).then(response => {
            return {
                data: response.data,
                headers: response.headers, // Total data dari header
            };
        });
    },
    totalAllAnswer(search, company){
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get(`/count-data/m151_answers/answer/${sanitizedSearch}/${company}`);
    },
    addAnswer(answer){
        return axiosInstance.post('/insert-data/m151_answers/', answer);
    },
    updateAnswer(answer){
        return axiosInstance.put('/update-data/m151_answers/'+ answer.id, answer);
    },
    deleteAnswer(id){
        return axiosInstance.delete(`/delete-data/m151_answers/${id}`);
    }
}

export default answerService;